import "./ConsultingServices.module.css";
import Header from "@/reusable_sections/Header";
import OurCapabilities from "./sections/OurCapabilities";
import DeploymentStages from "./sections/DeploymentStages";
import ReadyToOptimize from "./sections/ReadyToOptimize";
import FooterEssentials from "@/reusable_sections/Footer";
export default function ConsultingServicesPage() {
  return <div>
      <Header />
      <OurCapabilities />
      <DeploymentStages />
      <ReadyToOptimize />
      <FooterEssentials />
    </div>;
}